import { render, staticRenderFns } from "./LoginSplitLayout.vue?vue&type=template&id=1a001daa&scoped=true"
import script from "./LoginSplitLayout.vue?vue&type=script&lang=js"
export * from "./LoginSplitLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginSplitLayout.vue?vue&type=style&index=0&id=1a001daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a001daa",
  null
  
)

export default component.exports